import React from 'react';
import styled from 'styled-components';

export default props => <Divider {...props}/>;

const Divider = styled.div`
    width: 100%;
    height: 1px;
    background-color: ${props => props.theme.colors.alt};
`